module.exports = __webpack_public_path__ + "img/earth.46b6c1b9.png";